import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_META = {
  title: 'DaysMatter 倒數日｜紀念日、重要日期與回憶倒數工具',
  description: 'DaysMatter 倒數日提供免費又簡單的紀念日與重要日期管理服務，讓你建立生日、旅行、戀愛、考試和工作事件，查看未來倒數與過去天數，使用多種主題整理回憶，並生成適合 Instagram 貼文與限時動態的精美分享卡；登入後還能跨裝置保存資料，隨時掌握每個值得期待與珍藏的日子。'
};

const NOT_FOUND_META = {
  title: '找不到頁面｜DaysMatter 倒數日與紀念日工具',
  description: '你造訪的 DaysMatter 頁面不存在或已經移動，請返回首頁繼續建立與管理生日、旅行、戀愛紀念日、工作期限及其他重要事件。'
};

const PAGE_META = {
  '/': DEFAULT_META,
  '/features': {
    title: 'DaysMatter 功能介紹｜紀念日倒數、日期追蹤與精美分享卡片',
    description: '探索 DaysMatter 的紀念日與重要日期管理功能，包括未來事件倒數、過去天數追蹤、分類和置頂整理、多款卡片主題、深色模式，以及適合 Instagram 貼文與限時動態的圖片匯出；你也能使用訪客模式立即體驗，或登入帳戶跨裝置保存每一段值得珍藏的回憶。'
  },
  '/help': {
    title: 'DaysMatter 使用幫助｜常見問題、關於我們與聯絡方式',
    description: '查看 DaysMatter 倒數日的常見問題與操作說明，了解如何新增紀念日、計算相隔天數、跨裝置保存事件，以及製作適合社群分享的日期卡片；本頁也介紹由 Homy Tech Limited 經營的開發團隊，並提供 info@homy.hk 聯絡信箱，方便回報問題或提出功能建議。'
  },
  '/about': {
    title: '關於 DaysMatter｜Homy Tech 團隊理念與聯絡方式',
    description: '認識由 Homy Tech Limited 開發及營運的 DaysMatter 倒數日，了解我們為何打造這款紀念日、生日、旅行與重要日期管理工具，以及如何透過 info@homy.hk 聯絡團隊、回報問題、提出功能建議或洽談合作。'
  },
  '/login': {
    title: 'DaysMatter 帳戶登入與註冊｜跨裝置保存倒數日與紀念日',
    description: '登入或註冊 DaysMatter 帳戶，把生日、旅行、戀愛紀念日、考試、工作期限與其他重要事件安全保存到雲端，在手機與電腦之間同步查看未來倒數和過去回憶；尚未準備建立帳戶也能先以訪客模式體驗所有基本日期管理、卡片主題與分享圖片功能。'
  },
  '/reset-password': {
    title: 'DaysMatter 重設密碼｜恢復倒數日與紀念日帳戶存取',
    description: '透過 DaysMatter 密碼重設流程恢復帳戶存取，重新查看已保存的生日、旅行、戀愛紀念日、工作期限與其他重要事件；提交註冊信箱後依照郵件中的安全連結設定新密碼，即可再次在手機或電腦登入，繼續管理未來倒數、過去回憶與精美分享卡片。'
  }
};

function updateMeta(selector, content) {
  const element = document.querySelector(selector);
  if (element) element.setAttribute('content', content);
}

export default function SeoMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isKnownPage = Boolean(PAGE_META[pathname]);
    const meta = PAGE_META[pathname] || NOT_FOUND_META;
    const canonicalPath = isKnownPage
      ? pathname === '/' ? '/' : `${pathname}/`
      : '/';
    const canonicalUrl = `https://daysmatter.homy.hk${canonicalPath}`;

    document.title = meta.title;
    updateMeta('meta[name="description"]', meta.description);
    updateMeta('meta[name="robots"]', isKnownPage ? 'index, follow' : 'noindex, follow');
    updateMeta('meta[property="og:title"]', meta.title);
    updateMeta('meta[property="og:description"]', meta.description);
    updateMeta('meta[property="og:url"]', canonicalUrl);
    updateMeta('meta[name="twitter:title"]', meta.title);
    updateMeta('meta[name="twitter:description"]', meta.description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
}